import { render, staticRenderFns } from "./newsearchOrderList.vue?vue&type=template&id=01ec2c34&scoped=true&"
import script from "./newsearchOrderList.vue?vue&type=script&lang=js&"
export * from "./newsearchOrderList.vue?vue&type=script&lang=js&"
import style0 from "./newsearchOrderList.vue?vue&type=style&index=0&id=01ec2c34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ec2c34",
  null
  
)

export default component.exports